<template>
  <v-btn  outline class="UXbtn header-btn" @click="goTicketCreate" :disabled="disabled">
    新規追加
  </v-btn>
</template>

<script>
export default {
  name: 'addNewTicketButton',
  props: ['disabled'],
  methods: {
    goTicketCreate () {
      /* Domain에 따라서 DetailPage 분기: Gnb 이슈 */
      this.$router.push(this.$route.path === '/ticket/list' ? '/ticket/list/ticket_create' : '/ticket/ticket_create')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/menus/ticket/component/ticketlist/button/addNewTicketButton.vue